import React from 'react';
import { Row, Col, Typography, Divider } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Spinner } from '../../components/Spinner';
import ArrowUpperRight from '../../assets/icons/arrow-up-right.svg';
import { HUBSPOT_PORTAL_IDS, hubspotAuthorUrl } from '../../core/constants/global-constants';
import { getEnv } from '../../config/env-config';

const { Title, Link } = Typography;

const env = getEnv();

interface IClosedDealNote {
  deal_id: number;
  amazonasin: string | null;
  book_title: string | null;
  closed_deal_notes: string;
  last_modified: string | null;
}

interface IClosedDealNotesData {
  author: string;
  closed_deal_notes: IClosedDealNote[];
}

interface IOverlayClosedDealNotesProps {
  authorName: string;
  isClosedDealNotesLoading: boolean;
  closedDealNotesData?: IClosedDealNotesData | null;
}

const OverlayClosedDealNotes: React.FC<IOverlayClosedDealNotesProps> = ({
  authorName,
  isClosedDealNotesLoading,
  closedDealNotesData
}) => {
  if (!authorName || !closedDealNotesData) {
    return null;
  }

  const validNotes = closedDealNotesData.closed_deal_notes.filter(
    (note) => note.closed_deal_notes && note.closed_deal_notes.trim() !== ''
  );

  if (validNotes.length === 0) {
    return null;
  }

  const hubspotContactsUrl = `${hubspotAuthorUrl}${HUBSPOT_PORTAL_IDS[env]}`;

  return (
    <>
      <Divider style={{ margin: '14px 0' }} />
      <Title level={5} style={{ margin: '16px 0 8px 0' }}>
        Latest deal notes for {authorName}
      </Title>
      {isClosedDealNotesLoading ? (
        <div style={{ margin: '10px 0', textAlign: 'center' }}>
          <Spinner
            size='default'
            spinning={isClosedDealNotesLoading}
            indicator={<LoadingOutlined />}
          />
        </div>
      ) : (
        <div className='overlay-table closed-deal-notes-table'>
          {validNotes.map((note, index) => (
            <Row
              className={index % 2 === 0 ? 'overlay-odd-row' : 'overlay-even-row'}
              key={note.deal_id}
            >
              <Col span={24} className='overlay-column closed-deal-note-cell'>
                <p className='closed-deal-note-text'>{note.closed_deal_notes}</p>
                {note.book_title && (
                  <span className='closed-deal-note-subtitle'>{note.book_title}</span>
                )}
              </Col>
            </Row>
          ))}
          <Row>
            <Col span={24} className='author-sales-col'>
              <Link
                href={hubspotContactsUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='author-sales-link'
              >
                See all notes on HubSpot{' '}
                <img
                  src={ArrowUpperRight}
                  alt='Open in new tab'
                  style={{ width: 16, height: 16, marginLeft: 4 }}
                />
              </Link>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default OverlayClosedDealNotes;
